import React from 'react'
import { GridElement } from '..'
import { CmsLinkComponent } from '../../feComponents/cmsLink/CmsLink'
import { CmsImage } from '../../feComponents'
import { Icon } from '@vista-digital/occ-ui/src/lib/subcomponents/icon/icon'

import './image-text-cta-block.scss'

export const ImageTextCTABlock: React.FC<GridElement> = props => {
    const { title, mainCopyText, link, image } = props.value

    return (
        <div className='image-text-cta-block'>
            <CmsImage image={image} />
            <div>
                <h3 className='image-text-cta-block__title'>{title}</h3>
                <p className='image-text-cta-block__copy'>{mainCopyText}</p>
                {link &&
                    <>
                        <CmsLinkComponent link={link} />
                        <Icon name="arrowLeft" className="image-text-cta-block__arrow" />
                    </>
                }
            </div>
        </div>
    )
}
